import { Component, OnInit } from '@angular/core';
import { AbstractComponent } from '../util/abstract.component';
import { SessaoService } from '../services/sessao.service';
import { OutroServico } from '../modelo/outroServico';

declare var $ :any;

@Component({
  selector: 'app-outros-servicos',
  templateUrl: './outros-servicos.component.html',
  styleUrls: ['./outros-servicos.component.css']
})
export class OutrosServicosComponent extends AbstractComponent implements OnInit {

  outroServicoList: OutroServico[] = [];

  constructor(private sessaoService: SessaoService) {
    super(sessaoService);
  }

  ngOnInit() {
    // Menu
    $(".btsMenu .btn").removeClass("active");
    $(".outros").addClass("activeDrop");
    
    // Collapse
    $('.collapsible').collapsible();

    //Scroll top
    window.scrollTo(0,0);

    // Carrega a lista de outros serviços da sessão
    this.outroServicoList = this.sessaoService.sessao.configuracaoVisual.listaOutroServico;

    // Close Menu Mobile
    var isMobile = window.matchMedia("only screen and (max-width: 760px)");
    $(".content").click(function() {
      if (isMobile.matches) {
        $(".page").removeClass("toggled");
      }
    });
  }
  
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/bf-outros-servicos-cli/outros-servicos.component.ts